import React, {useState, useEffect, useRef} from "react";
import GenericTemplate from "../../templates/GenericTemplate";
import {apollo_useStyles, zeroDate, valueToOption, options_infostate} from "../../atom/Apollo_styles";
import {
  apollo_info_path,
  info_path,
  infoedit_path,
  apollo_message_history_path,
} from "../../atom/Apollo_links";
import {APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN, ApolloPageUsagePermission} from "../../atom/Apollo_Authorization";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge";
import {ApolloBreadcrumbs} from "../../atom/Apollo_Breadcrumbs";
import {Info} from "./NotifyModel";
import {DeleteButton} from "../../molecule/Apollo_Button";
import {ApolloContext} from "../../atom/Apollo_Context";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
// メッセージ定義
import {
  GetMessage,
  UI_NOTIFY_DETAIL,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";
// TODO操作ログ
import {ApolloEventRecord, LogData, ItemList} from "../../atom/Apollo_EventRecord";


import {useHistory, useParams, Link} from "react-router-dom";

import Typography from '@material-ui/core/Typography';
import Chip from "@material-ui/core/Chip";
import Collapse from "@material-ui/core/Collapse/Collapse";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Fab from "@material-ui/core/Fab";
import EditIcon from '@material-ui/icons/Edit';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";
import CardActions from "@material-ui/core/CardActions/CardActions";
import moment from "moment";
import Grid from "@material-ui/core/Grid";

/*
    画面名：通知メッセージ詳細
 */
const NotifyDetail: React.FC = () => {
  const classes = apollo_useStyles();
  let history = useHistory();

  const {infoid} = useParams<{infoid: string}>();
  const {state} = React.useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const [open, setOpen] = React.useState(false);
  const [info, setInfo] = useState<Info>();
  const [sendButtonDisabled, setSendButtonDisabled] = React.useState(false);
  // 操作ログ仕様変数
  const resultApi = useRef(-1);
  const logTime = useRef("");
  const actionType = useRef(0); // 0:参照 1:新規 2:更新 3:削除 4:アップロード
  const processing = useRef(false);

  const products = [
    {name: 'タイトル', desc: '', value: info?.infoName},
    {name: 'ステータス', desc: '', value: info?.status ? valueToOption(info?.status ?? "", options_infostate).label : ""},
    {
      name: '配信開始日時',
      desc: '',
      value: info?.createdAt !== zeroDate ? moment(info?.startAt).format("YYYY-MM-DD HH:mm") : ""
    },
    {
      name: '作成日',
      desc: '',
      value: info?.createdAt !== zeroDate ? moment(info?.createdAt).format("YYYY/MM/DD HH:mm") : ""
    },
    {
      name: '更新日',
      desc: '',
      value: info?.modifiedAt ? moment(info?.modifiedAt).format("YYYY/MM/DD HH:mm") : ""
    },
    {name: '最終更新ユーザー', desc: '', value: info?.modifiedBy},
  ];

  useEffect(() => {
    const url = apollo_info_path + infoid;
    ApolloAxios.get(url).then((response) => {
      if (response.data.result.infoName === undefined) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_NOTIFY_DETAIL,"E","3")
          }
        });
      }
      setInfo(response.data.result);
      if (response.data.result.status !== 1 || response.data.result.sendMail || !response.data.result.relationUsers) {
        setSendButtonDisabled(true);
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_NOTIFY_DETAIL,"E","0"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  }, []);

  // 削除ハンドラ
  const handleDelete = () => {
    if (processing.current) return;
    processing.current = true;
    // 操作日時をセット
    logTime.current = moment().format("YYYY-MM-DD HH:mm:ss");
    // 操作ログ(実行)
    resultApi.current = 0;
    // 操作ログアクション(削除)
    actionType.current = 3;
    writeLog();

    const url = apollo_info_path + infoid;
    ApolloAxios.delete(url).then((response) => {
      // 操作ログ(成功)
      resultApi.current = 1;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "success",
          message: GetMessage("0",UI_NOTIFY_DETAIL,"I","0")
        }
      });
      history.push(info_path);
    }).catch(err => {
      // 操作ログ(失敗)
      resultApi.current = 9;
      // const errMsg = err.error.response.data.message ? err.error.response.data.message : "削除に失敗しました";
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_NOTIFY_DETAIL,"E","1"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
      // setmsg({
      //   type: "setMessage",
      //   payload: {
      //     ...data,
      //     open: true,
      //     type: "error",
      //     message: errMsg,
      //   }
      // });
    }).finally(() => {
      // 操作ログ出力(結果)
      writeLog();
      // 処理終了時にprocessingをfalseにする
      processing.current = false;
    });
  };

  // メール送信ハンドラ
  const handelSendMail = () => {
    setSendButtonDisabled(true);
    const url = apollo_message_history_path + infoid;
    ApolloAxios.post(url).then((response) => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "success",
          message: GetMessage("0",UI_NOTIFY_DETAIL,"I","1")
        }
      });
      // history.push(info_path);
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_NOTIFY_DETAIL,"E","2"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  };

  // 戻るハンドラ
  const handelGoback = () => {
    const url = info_path;
    history.push(url);
  };

  // 操作ログ出力
  const writeLog = () => {
    // 操作ログ出力を呼ばれるまでは処理しない
    if (resultApi.current < 0) return;
    // 項目リスト
    var key = "";
    var beforeValue = "";
    var afterValue = "";
    switch (actionType.current) {
      case 0: // 参照
        break;
      case 1: // 新規
        break;
      case 2: // 更新
        break;
      case 3: // 削除
        key = "論理削除フラグ";
        beforeValue = "0";
        afterValue = "1";
        break;
      case 4: // アップロード
        break;
      default: // 不明
        key = "不明";
    }
    // 項目リスト
    const itemList: ItemList[] = [];
    // 操作ログ
    const executionLog: LogData = {
      eventDate: logTime.current, // イベント日時 “YYYY-MM-DD HH:mm:ss“ 形式
      logType: resultApi.current === 0 ? "execute" : "result",// ログ種別 実行：execute, 結果：result
      result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",// 実行結果 成功 / 失敗 ※実行時は空文字
      userID: state.userprofile.userId,// ユーザID
      userName: state.userprofile.userName,// Apolloユーザ名 姓 + 半角スペース + ユーザ名
      accessToken: state.accesstoken, // APIアクセス用トークン
      accountGroupID: state.current.accountGroupId, // アカウントグループID
      accountGroupName: state.current.accountGroupName, // アカウントグループ名
      accountID: state.current.accountId, // 広告主アカウントID
      accountName: state.current.accountName, // 広告主アカウント名
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "", // メニュー パフォーマンス広告 / メール広告 / ディスプレイ広告
      displayName: "通知メッセージ一覧画面", // 操作画面名称 〇〇画面
      category: "メッセージ", // 操作対象 キャンペーン / セグメント etc...
      actionType: actionType.current === 0 ? "参照" : actionType.current === 1 ? "作成" : actionType.current === 2 ? "更新" : actionType.current === 3 ? "削除" : actionType.current === 4 ? "アップロード" : "不明", // アクション 参照 / 作成 / 更新 / 削除 / アップロード
      targetID: resultApi.current === 0 ? "" : infoid + "", // 操作を行うデータのID 実行時は空文字
      targetName: resultApi.current === 0 ? "" : "メッセージID", // 操作を行うデータの名称 実行時は空文字
      itemList: itemList,
    }
    // 操作ログ出力
    ApolloEventRecord(executionLog);
  };

  return (
    <GenericTemplate title="">

      <ApolloPageUsagePermission role={APOLLO_SYSTEM_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
        <ApolloBreadcrumbs bread_no={35} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={""}
                            platform={""}/>

        <Fab color="primary" aria-label="edit" className={classes.fab2}>
          <Link to={infoedit_path + infoid} className={classes.link}>
            <EditIcon/>
          </Link>
        </Fab>
        <Fab color="primary" aria-label="del" className={classes.fab}>
          <DeleteButton handleDelete={handleDelete} title="通知メッセージ削除" text={`この通知メッセージを削除しますか？`}/>
        </Fab>
        <React.Fragment>
          <Card className={classes.root} square variant="outlined">
            <CardContent>
                <Grid container spacing={3} style={{marginBottom:"5px"}}>
                  {products?.map((product, index) => (
                    <React.Fragment key={index}>
                      <Grid item xs={6}>
                        <Typography>{product.name}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>{product.value}</Typography>
                      </Grid>
                    </React.Fragment>
                  ))}
                </Grid>
              <Divider/>
              <Grid>
                <Typography style={{marginTop:"5px"}}>配信ユーザー</Typography>
              </Grid>
              <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                {open ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
              </IconButton>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Grid>
                  {info?.relationUsers?.map((user) => (
                    <Chip label={user.userName} variant="outlined"/>
                  ))}
                </Grid>
              </Collapse>
              <Grid>
                <Typography style={{marginTop:"10px"}}>本文</Typography>
              </Grid>
              <Grid>
                <div style={{whiteSpace: "pre-line"}}>{info?.infoText}</div>
              </Grid>
              <Divider/>
              {/* 後で消すこと。追加する送信ボタンと送信履歴 */}
              <Button
                variant="contained"
                color="primary"
                onClick={handelSendMail}
                className={classes.button}
                disabled={sendButtonDisabled}
              >
                メールを送信する
              </Button>
              <Card className={classes.root} square variant="outlined" style={{padding: '5px'}}>
                <CardContent style={{padding: '5px'}}>
                  <Typography style={{marginTop:"5px"}}>送信履歴</Typography>
                </CardContent>
                {info?.mailHistories?.map((history) => 
                  <CardContent style={{padding: '0px'}}>
                    <Card className={classes.root} square variant="outlined" style={{padding: '0px'}}>
                      <CardContent style={{padding: '5px'}}>
                        <Grid container spacing={0}>
                          <Grid item xs={12}>
                            <Typography variant="subtitle2" style={{marginTop:"5px"}}>
                              <strong>送信日時：</strong>{moment(history.sendRequestAt).format('YYYY/MM/DD HH:mm:ss')}  <strong>{history.infoStatus === 1 ? "送信成功" : history.infoStatus === 2 ? "送信失敗" : "未送信"}</strong>
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <div style={{whiteSpace: "pre-line"}}>
                              <strong>宛先：</strong>{history.sendAddressHistory ? history.sendAddressHistory.replace(/,/g, ' ') : ""}
                            </div>
                          </Grid>
                          <Grid item xs={12}>
                            <Typography variant="subtitle2" style={{marginTop:"5px"}}>
                              <strong>タイトル：</strong>{history.infoName}
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <div style={{whiteSpace: "pre-line"}}>
                              <strong>本文：</strong>{history.infoText}
                            </div>
                          </Grid>
                          <Collapse in={open} timeout="auto" unmountOnExit>
                            <Grid>
                              {info?.relationUsers?.map((user) => (
                                <>
                                  {user.userName}
                                </>
                              ))}
                            </Grid>
                          </Collapse>
                        </Grid>
                      </CardContent>
                    </Card>
                  </CardContent>
                )}
              </Card>

              {/* 後で消すこと。追加する送信ボタンと送信履歴 */}
              </CardContent>
            <CardActions className={classes.cardaction}>
              <Button
                variant="contained"
                color="primary"
                onClick={handelGoback}
                className={classes.button}
              >
                戻る
              </Button>
            </CardActions>
          </Card>
        </React.Fragment>
      </ApolloPageUsagePermission>
      <CustomizedSnackbars/>
    </GenericTemplate>
  );
};

export default NotifyDetail;
